export default {
  name: 'yotpoReviewForm',
  component(config) {
    return {
      // Form data
      rating: 0,
      hoverRating: 0,
      form: {
        headline: '',
        body: '',
        name: '',
        email: ''
      },
      images: [],

      // UI state
      loading: false,
      success: false,
      dragover: false,
      errors: {},

      // File handling
      handleFileSelect(event) {
        this.processFiles(event.target.files);
      },

      handleDrop(event) {
        this.dragover = false;
        this.processFiles(event.dataTransfer.files);
      },

      processFiles(fileList) {
        Array.from(fileList).forEach((file) => {
          if (this.validateFile(file)) {
            const reader = new FileReader();
            reader.onload = (e) => {
              this.images.push({
                file: file,
                name: file.name,
                preview: e.target.result
              });
            };
            reader.readAsDataURL(file);
          }
        });
      },

      validateFile(file) {
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (!validTypes.includes(file.type)) {
          alert('{{ "reviews.form.invalid_file_type" | t | default: "Please upload only JPG, PNG, or GIF images." }}');
          return false;
        }

        if (file.size > maxSize) {
          alert('{{ "reviews.form.file_too_large" | t | default: "File size must be less than 5MB." }}');
          return false;
        }

        return true;
      },

      removeImage(index) {
        this.images.splice(index, 1);
      },

      // Validation
      validateForm() {
        this.errors = {};

        if (this.rating === 0) {
          this.errors.rating = 'A star rating is required';
        }

        if (!this.form.headline.trim()) {
          this.errors.headline = 'Review headline is required';
        }

        if (!this.form.body.trim()) {
          this.errors.body = 'Review content is required';
        }

        if (!this.form.name.trim()) {
          this.errors.name = 'A name is required';
        }

        if (!this.form.email.trim()) {
          this.errors.email = 'A valid email address is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
          this.errors.email = 'A valid email address is required';
        }

        return Object.keys(this.errors).length === 0;
      },

      // Form submission
      async submitReview() {
        if (!this.validateForm()) {
          return;
        }

        this.loading = true;

        try {
          // Prepare form data
          const formData = new FormData();

          // Add form fields
          formData.append('appKey', this.appKey);
          formData.append('review_score', this.rating);
          formData.append('review_title', this.form.headline);
          formData.append('review_content', this.form.body);
          formData.append('display_name', this.form.name);
          formData.append('email', this.form.email);

          // Add product info
          formData.append('sku', this.productId);
          formData.append('product_title', this.productTitle);

          // Add images
          this.images.forEach((image, index) => {
            formData.append(`image_urls[${index}]`, image.file);
          });

          // Submit to your backend endpoint
          const response = await fetch('https://api.yotpo.com/reviews/dynamic_create', {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });

          const result = await response.json();

          if (response.ok) {
            this.success = true;
            // Reset form
            this.rating = 0;
            this.form = {
              headline: '',
              body: '',
              name: '',
              email: ''
            };
            this.images = [];

            // Scroll to success message
            this.$el.scrollIntoView({ behavior: 'smooth' });
          } else {
            alert(
              result.error ||
                '{{ "reviews.form.error_generic" | t | default: "Something went wrong. Please try again." }}'
            );
          }
        } catch (error) {
          console.error('Review submission error:', error);
          alert(
            '{{ "reviews.form.error_network" | t | default: "Network error. Please check your connection and try again." }}'
          );
        } finally {
          this.loading = false;
        }
      }
    };
  }
};
